@if (field.type === 'text' || field.type === 'hiddenInput' || field.type === 'phone' || field.type === 'email' || (field.type ===
  'flightNumber' && formGroup.controls[field.property]?.value && formGroup.controls[field.property]?.value !== '')) {
  {{formGroup.controls[field.property]?.value}}
}

@if (field.type === 'textArea') {
  {{formGroup.controls[field.property]?.value}}
}

@if (field.type === 'dateTime') {
  {{this.displayTime}} {{this.timeZoneOffset}}
}

@if (field.type === 'address' || field.type === 'hiddenInputAddress') {
  {{(formGroup.controls[field.property]?.value && formGroup.controls[field.property]?.value.formatted_address ?
  formGroup.controls[field.property]?.value.formatted_address :
  formGroup.controls[field.property]?.value)}}
}

@if (field.type === 'number' && formGroup.controls[field.property]?.value !== 0) {
  {{formGroup.controls[field.property]?.value}}
}
@if (field.type === 'sortable-address' && getArray().length > 0) {
  <ul>
    @for (stopOver of getArray(); track stopOver; let fi = $index) {
      <li>
        {{(stopOver.value && stopOver.value.formatted_address ?
        stopOver.value.formatted_address :
        stopOver.value)}}
      </li>
    }
  </ul>
}

@if (field.type === 'checkbox') {
  {{(formGroup.controls[field.property]?.value ? 'yes' : 'no') | translate | ucFirst}}
}

@if (field.type === 'select') {
  @for (value of field.values; track value) {
    @if (isSelectValue(value.value, $safeNavigationMigration(formGroup.controls[field.property]?.value))) {
      {{value.label | labelKeyMore:value.value | translate | ucFirst | unicorn:value.value}}
    }
  }
}
